<!--
 * @Author: czj
 * @Date: 2025-04-09 15:51:28
 * @Description: 
 * @FilePath: \test-demo2\src\components\ContentCom\index.vue
-->
<template>
  <div :class="'content '+(isFold?'content_fold':'')">
    <template v-for="(item,index) in props.data">
      <UnitContentCom :item_data="item" :input_json="props.input_json" :output_json="props.output_json"
        :task_result="props.task_result">{{ index+1 }}</UnitContentCom>
    </template>
  </div>
</template>
<script setup>
  import { ref, defineProps, watch, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted, defineEmits } from 'vue';


  //src\components\ContentCom\UnitContentCom.vue
  import UnitContentCom from './UnitContentCom.vue';

  const emit = defineEmits([])
  const props = defineProps(['data', 'input_json', 'output_json', 'task_result']);

  const isFold = ref(false);//是否折叠

  // 使用 watch 监听 props 的字段变化
  watch(() => props, (newData, oldData) => {
  });
  //组件即将挂载
  onBeforeMount(() => {
  });
  //组件已经挂载
  onMounted(() => {
  });
  //组件即将更新
  onBeforeUpdate(() => {
  });
  //组件已经更新
  onUpdated(() => {
  });
  //组件即将卸载
  onBeforeUnmount(() => {
  });
  //组件已经卸载
  onUnmounted(() => {
  });
</script>
<style scoped></style>